module.exports = __webpack_public_path__ + "static/media/mi_cooperativa.be69e9df.svg";